import dispatcher from "../dispatchers/dispatcher";
import { EventEmitter } from "events";
import * as Actions from "../actions/action";

class Store extends EventEmitter {

    constructor() {
        super();
        this.user_listInfo = null;
        this.user_creatorListInfo = null;
        this.user_accountInfo = null;
        this.user_favoritesInfo = null;
        this.user_sharedInfo = null;
        this.user_layoutInfo = null;
        this.user_ratingsInfo = null;
        this.user_highScoreInfo = null;
        this.user_topUsersHighScoreInfo = null;
        this.user_permissionlistInfo = null;
        this.user_userswithpermissionslistInfo = null;
        this.resource_reportTypeListInfo = null;
        this.resource_qrsYearListInfo = null;
        this.resource_resourceTypeListInfo = null;
        this.resource_intellisenseInfo = null;
        this.resource_singleResourceInfo = null;
        this.resource_listByTypeInfo = null;
        this.resource_relationshipInfo = null;
        this.resource_topReportsInfo = null;
        this.resource_topTagsInfo = null;
        this.resource_topRatedReportsInfo = null;
        this.resource_newestReportsInfo = null;
        this.resource_imageInfo = null;
        this.resource_thumbimageInfo = null;
        this.resource_fullimageInfo = null;
        this.resource_tagInfo = null;
        this.resource_reportAndMetricLinkInfo = null;
        this.singleResource_ImageInfo = null;
        this.singleResource_RelationshipInfo = null;
        this.singleResource_APGoalsInfo = null;
        this.singleResource_APGoalsLinkedResourcesInfo = null;
        this.singleResource_APActionsInfo = null;
        this.singleResource_APTeamInfo = null;
        this.singleResource_MetricOwnerInfo = null;
        this.singleResource_MetricGoalsInfo = null;
        this.singleResource_APLogInfo = null;
        this.singleResource_CCNAttributeInfo = null;
        this.singleResource_DisplaysInInfo = null;
        this.singleResource_TagInfo = null;
        this.singleResource_CreateInfo = null;
        this.resource_DisplaysInInfo = null;
        this.resource_rankListInfo = null;
        this.accessGroups = [];
        this.employeeList = [];
        this.employeeAccessGroups = [];
        this.addEmployeeAccessGroupError = false;
        this.removeEmployeeAccessGroupError = false;
        this.actionGroupFileList = [];
        this.actionGroupFileUploadedInfo = [];
    }


    handleActions(action) {
        switch (action.type) {
            case Actions.ACTIONS.UPDATE_USER_LISTINFO:
                this.user_listInfo = action.data;
                this.emit("Response_User_ListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_CREATORLISTINFO:
                this.user_creatorListInfo = action.data;
                this.emit("Response_User_CreatorListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_REPORTTYPELISTINFO:
                this.resource_reportTypeListInfo = action.data;
                this.emit("Response_Resource_ReportTypeListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_QRSYEARLISTINFO:
                this.resource_qrsYearListInfo = action.data;
                this.emit("Response_Resource_QRSYearListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_RESOURCETYPELISTINFO:
                this.resource_resourceTypeListInfo = action.data;
                this.emit("Response_Resource_ResourceTypeListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_ACCOUNTINFO: 
            case Actions.ACTIONS.UPDATE_SPOOFED_USER_ACCOUNTINFO:
                this.user_accountInfo = action.data;
                this.emit("Response_User_AccountInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_INTELLISENSEINFO:
            case Actions.ACTIONS.UPDATE_RESOURCE_OPTIMIZEDINTELLISENSEINFO:
                this.resource_intellisenseInfo = action.data;
                this.emit("Response_Resource_IntellisenseInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_LISTBYTYPEINFO:
                this.resource_listByTypeInfo = action.data;
                this.emit("Response_Resource_ListByTypeInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_RANKLISTINFO:
                this.resource_rankListInfo = action.data;
                this.emit("Response_Resource_RankListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_RANKREMOVED:
            case Actions.ACTIONS.UPDATE_RESOURCE_RANKADDED:
            case Actions.ACTIONS.UPDATE_RESOURCE_RANKEDITTED:
                this.emit("Response_Resource_Rank_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_RELATIONSHIPINFO:
                this.resource_relationshipInfo = action.data;
                this.emit("Response_Resource_RelationshipInfo_Updated");
                break;   
            case Actions.ACTIONS.UPDATE_USER_THEMEINFO:
                this.emit("Response_User_ThemeInfo_Updated");
                break;          
            case Actions.ACTIONS.UPDATE_USER_PERMISSIONREMOVED:
            case Actions.ACTIONS.UPDATE_USER_PERMISSIONADDED:
                this.emit("Response_User_PermissionsUpdated");
                break;
            case Actions.ACTIONS.UPDATE_USER_LAYOUTINFO:
                this.user_layoutInfo = action.data;
                this.emit("Response_User_LayoutInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_PERMISSIONLISTINFO:
                this.user_permissionlistInfo = action.data;
                this.emit("Response_User_PermissionListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_USERSWITHPERMISSIONSLISTINFO:
                this.user_userswithpermissionslistInfo = action.data;
                this.emit("Response_User_UsersWithPermissionsListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_FAVORITESINFO:
                this.user_favoritesInfo = action.data;
                this.emit("Response_User_FavoritesInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_SHAREDINFO:
                this.user_sharedInfo = action.data;
                this.emit("Response_User_SharedInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_RATINGSINFO:
                this.user_ratingsInfo = action.data;
                this.emit("Response_User_RatingsInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_RATING_UPVOTE:
            case Actions.ACTIONS.UPDATE_USER_RATING_DOWNVOTE:
            case Actions.ACTIONS.UPDATE_USER_RATING_REMOVED:
                this.emit("Response_User_RatingsInfo_Changed");
                break;
            case Actions.ACTIONS.UPDATE_USER_FAVORITE_ADDED:
            case Actions.ACTIONS.UPDATE_USER_FAVORITE_REMOVED:
                this.emit("Response_User_FavoritesInfo_Changed");
                break;
            case Actions.ACTIONS.UPDATE_USER_HIGHSCOREINFO:
                this.user_highScoreInfo = action.data;
                this.emit("Response_User_HighScoreInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_USER_TOPUSERSHIGHSCOREINFO:
                this.user_topUsersHighScoreInfo = action.data;
                this.emit("Response_User_TopUsersHighScoreInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_TOPREPORTSINFO:
                this.resource_topReportsInfo = action.data;
                this.emit("Response_Resource_TopReportsInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_TOPTAGSINFO:
                this.resource_topTagsInfo = action.data;
                this.emit("Response_Resource_TopTagsInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_TOPRATEDREPORTSINFO:
                this.resource_topRatedReportsInfo = action.data;
                this.emit("Response_Resource_TopRatedReportsInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_NEWESTREPORTSINFO:
                this.resource_newestReportsInfo = action.data;
                this.emit("Response_Resource_NewestReportsInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_IMAGEINFO:
                this.resource_imageInfo = action.data;
                this.emit("Response_Resource_ImageInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_THUMB_IMAGEINFO:
                this.resource_thumbimageInfo = action.data;
                this.emit("Response_Resource_Thumb_ImageInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_FULLIMAGEINFO:
                this.resource_fullimageInfo = action.data;
                this.emit("Response_Resource_FullImageInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_TAGINFO:
                this.resource_tagInfo = action.data;
                this.emit("Response_Resource_TagInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_REPORTANDMETRICLINKINFO:
                this.resource_reportAndMetricLinkInfo = action.data;
                this.emit("Response_Resource_ReportAndMetricLinkInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_IMAGEINFO:
                this.singleResource_ImageInfo = action.data;
                this.emit("Response_SingleResource_ImageInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_RELATIONSHIPINFO:
                this.singleResource_RelationshipInfo = action.data;
                this.emit("Response_SingleResource_RelationshipInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APGOALSINFO:
                this.singleResource_APGoalsInfo = action.data;
                this.emit("Response_SingleResource_APGoalsInfo_Updated");
                break; 
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APGOALSADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APGOALSREMOVED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_MODIFYAPGOALS:
                this.emit("Response_SingleResource_APGoalsChange_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESINFO:
                this.singleResource_APGoalsLinkedResourcesInfo = action.data;
                this.emit("Response_SingleResource_APGoalsLinkedResourcesInfo_Updated");
                break;   
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APGOALSLINKEDRESOURCESREMOVED:
                this.emit("Response_SingleResource_APGoalsLinkedResourcesChange_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APACTIONSINFO:
                this.singleResource_APActionsInfo = action.data;
                this.emit("Response_SingleResource_APActionsInfo_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APACTIONSADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APACTIONSREMOVED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_MODIFYAPACTIONS:
                this.emit("Response_SingleResource_APActionsChange_Updated");
                break;   
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APTEAMINFO:
                this.singleResource_APTeamInfo = action.data;
                this.emit("Response_SingleResource_APTeamInfo_Updated");
                break;   
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APTEAMADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APTEAMREMOVED:
                this.emit("Response_SingleResource_APTeamChange_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_METRICOWNERINFO:
                this.singleResource_MetricOwnerInfo = action.data;
                this.emit("Response_SingleResource_MetricOwnerInfo_Updated");
                break;   
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_METRICOWNERADDED:
                this.emit("Response_SingleResource_MetricOwnerChange_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_METRICOWNERREMOVED:
                this.emit("Response_SingleResource_MetricOwnerRemoval_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_METRICGOALSINFO:
                this.singleResource_MetricGoalsInfo = action.data;
                this.emit("Response_SingleResource_MetricGoalsInfo_Updated");
                break; 
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_METRICGOALSADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_METRICGOALSREMOVED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_MODIFYMETRICGOALS:
                this.emit("Response_SingleResource_MetricGoalsChange_Updated");
                break; 
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APLOGINFO:
                this.singleResource_APLogInfo = action.data;
                this.emit("Response_SingleResource_APLogInfo_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APLOGADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_APLOGREMOVED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_MODIFYAPLOG:
                this.emit("Response_SingleResource_APLogChange_Updated");
                break;   
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_CCNATTRIBUTEINFO:
                this.singleResource_CCNAttributeInfo = action.data;
                this.emit("Response_SingleResource_CCNAttributeInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_RELATIONSHIPREMOVED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_RELATIONSHIPADDED:
                this.emit("Response_SingleResource_RelationshipChange_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_DISPLAYSININFO:
                this.singleResource_DisplaysInInfo = action.data;
                this.emit("Response_SingleResource_DisplaysInInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_TAGINFO:
                this.singleResource_TagInfo = action.data;
                this.emit("Response_SingleResource_TagInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_TAGADDED:
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_TAGREMOVED:
                this.emit("Response_SingleResource_TagChange_Updated");
                break;  
            case Actions.ACTIONS.UPDATE_RESOURCE_DISPLAYSININFO:
                this.resource_DisplaysInInfo = action.data;
                this.emit("Response_Resource_DisplaysInInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_IMAGE_UPLOAD:
                this.emit("Response_Resource_ImageInfo_Changed");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_IMAGE_REMOVED:
                this.emit("Response_Resource_ImageInfo_Removed");
                break;
            case Actions.ACTIONS.UPDATE_USER_VIEWED_RESOURCE:
                this.emit("Response_User_Viewed_Resource");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_ALLSYNC:
                this.emit("Response_Resource_ManualAllSync_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_SINGLESYNC:
                this.emit("Response_Resource_SingleSync_Updated");
                break;
            case Actions.ACTIONS.UPDATE_RESOURCE_GETSINGLERESOURCE:
                this.resource_singleResourceInfo = action.data;
                this.emit("Response_Resource_SingleResource_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_MODIFYSINGLERESOURCE:
                this.emit("Response_SingleResource_ModifySingleResource_Updated");
                break;
            case Actions.ACTIONS.UPDATE_SINGLERESOURCE_CREATESINGLERESOURCE:
                this.singleResource_CreateInfo = action.data;
                this.emit("Response_SingleResource_CreateSingleResource_Updated");
                break;
            case Actions.ACTIONS.UPDATE_EMPLOYEE_SEARCH_LIST:
                this.employeeList = action.data.result;
                this.emit("Response_Employee_SearchList_Updated");
                break;
            case Actions.ACTIONS.UPDATE_EMPLOYEE_ACCESSGROUPS:
                this.employeeAccessGroups = action.data.result;
                this.emit("Response_Employee_AccessGroupList_Updated");
                break;
            case Actions.ACTIONS.UPDATE_ACCESSGROUPS:
                this.accessGroups = action.data.result;
                this.emit("Response_AccessGroupList_Updated");
                break;
            case Actions.ACTIONS.UPDATE_EMPLOYEE_ACCESSGROUP_ADDED:
                this.addEmployeeAccessGroupError = action.data.result;
                this.emit("Response_Employee_AccessGroup_Added");
                break;
            case Actions.ACTIONS.UPDATE_EMPLOYEE_ACCESSGROUP_REMOVED:
                this.removeEmployeeAccessGroupError = action.data.result;
                this.emit("Response_Employee_AccessGroup_Removed");
                break;
            case Actions.ACTIONS.UPDATE_ACTIONGROUP_FILELIST:
                this.actionGroupFileList = action.data.result;
                this.emit("Response_File_ListInfo_Updated");
                break;
            case Actions.ACTIONS.UPDATE_ACTIONGROUP_FORMDATA_UPLOADED:
                this.actionGroupFileUploadedInfo = action.data;
                this.emit("Response_File_Uploaded");
                break;
            case Actions.ACTIONS.UPDATE_ACTIONGROUP_FILE_REMOVED:
                this.emit("Response_File_Deleted");
                break;
            case Actions.ACTIONS.UPDATE_USER_FAILEDVALIDATEDINFO:
                this.emit("Response_Validation_Failed");
                break;                
            default:
                break;
        }
    }
    getActionGroupFileUploadedInfo() {
        return this.actionGroupFileUploadedInfo;
    }

    getActionGroupFileList() {
        return this.actionGroupFileList;
    }
    getEmployeeSearchList() {
        return this.employeeList;
    }
    getAccessGroups() {
        return this.accessGroups;
    }
    getAddEmployeeAccessGroupError() {
        return this.addEmployeeAccessGroupError;
    }
    getRemoveEmployeeAccessGroupError() {
        return this.removeEmployeeAccessGroupError;
    }
    getEmployeeAccessGroups() {
        return this.employeeAccessGroups
    }
    clearEmployeeAccessGroups() {
        this.employeeList = [];
        this.employeeAccessGroups = [];
    }
    getEmployeeList() {
        return this.employeeList
    }
    getUser_ListInfo() {
        return this.user_listInfo;
    }
    getUser_CreatorListInfo() {
        return this.user_creatorListInfo;
    }
    getUser_AccountInfo() {
        return this.user_accountInfo;
    }
    getUser_LayoutInfo() {
        return this.user_layoutInfo;
    }
    getUser_PermissionListInfo() {
        return this.user_permissionlistInfo;
    }
    getUser_UsersWithPermissionsListInfo() {
        return this.user_userswithpermissionslistInfo;
    }
    getUser_FavoritesInfo() {
        return this.user_favoritesInfo;
    }
    getUser_SharedInfo() {
        return this.user_sharedInfo;
    }
    getUser_RatingsInfo() {
        return this.user_ratingsInfo;
    }
    getUser_HighScoreInfo() {
        return this.user_highScoreInfo;
    }
    getUser_TopUsersHighScoreInfo() {
        return this.user_topUsersHighScoreInfo;
    }
    getResource_ReportTypeListInfo() {
        return this.resource_reportTypeListInfo;
    }
    getResource_QRSYearListInfo() {
        return this.resource_qrsYearListInfo;
    }
    getResource_ResourceTypeListInfo() {
        return this.resource_resourceTypeListInfo;
    }
    getResource_ResourceRankListInfo() {
        return this.resource_rankListInfo;
    }
    getResource_IntellisenseInfo() {
        return this.resource_intellisenseInfo;
    }
    getResource_ListByTypeInfo() {
        return this.resource_listByTypeInfo;
    }
    getResource_RelationshipInfo() {
        return this.resource_relationshipInfo;
    }
    getResource_TopReportsInfo() {
        return this.resource_topReportsInfo;
    }
    getResource_TopTagsInfo(){
        return this.resource_topTagsInfo;
    }
    getResource_SingleResourceInfo() {
        return this.resource_singleResourceInfo;
    }
    getSingleResource_RelationshipInfo() {
        return this.singleResource_RelationshipInfo;
    }
    getSingleResource_APGoalsInfo() {
        return this.singleResource_APGoalsInfo;
    }
    getSingleResource_APGoalsLinkedResourcesInfo() {
        return this.singleResource_APGoalsLinkedResourcesInfo;
    }
    getSingleResource_APActionsInfo() {
        return this.singleResource_APActionsInfo;
    }
    getSingleResource_APTeamInfo() {
        return this.singleResource_APTeamInfo;
    }
    getSingleResource_MetricOwnerInfo() {
        return this.singleResource_MetricOwnerInfo;
    }
    getSingleResource_MetricGoalsInfo() {
        return this.singleResource_MetricGoalsInfo;
    }
    getSingleResource_APLogInfo() {
        return this.singleResource_APLogInfo;
    }
    getSingleResource_CCNAttributeInfo() {
        return this.singleResource_CCNAttributeInfo;
    }
    getSingleResource_DisplaysInInfo() {
        return this.singleResource_DisplaysInInfo;
    }
    getSingleResource_TagInfo() {
        return this.singleResource_TagInfo;
    }
    getResource_DisplaysInInfo() {
        return this.resource_DisplaysInInfo;
    }
    getResource_TopRatedReportsInfo() {
        return this.resource_topRatedReportsInfo;
    }
    getResource_NewestReportsInfo() {
        return this.resource_newestReportsInfo;
    }
    getResource_ImageInfo() {
        return this.resource_imageInfo;
    }
    getResource_ThumbImageInfo() {
        return this.resource_thumbimageInfo;
    }
    getResource_FullImageInfo() {
        return this.resource_fullimageInfo;
    }
    getResource_TagInfo() {
        return this.resource_tagInfo;
    }
    getResource_ReportAndMetricLinkInfo() {
        return this.resource_reportAndMetricLinkInfo;
    }    
    getSingleResource_ImageInfo() {
        return this.singleResource_ImageInfo;
    }
    getSingleResource_CreateInfo() {
        return this.singleResource_CreateInfo;
    }

}

const store = new Store();
dispatcher.register(store.handleActions.bind(store));
export default store;